var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("img", {
      staticClass: "w-24 h-24 mt-6 ml-2",
      attrs: { src: require("@/assets/img/logo.svg") }
    }),
    _vm.isLoading
      ? _c("div", { staticClass: "container center" }, [_vm._m(0)])
      : _vm._e(),
    _vm.isCompleted && !_vm.isLoading
      ? _c("div", { staticClass: "pt-10" }, [
          _vm.message
            ? _c("div", [_c("alert", { attrs: { message: _vm.message } })], 1)
            : _vm._e(),
          _vm.isSuccess
            ? _c("div", { staticClass: "flex flex-col px-6 mt-10" }, [
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      _vm.webDonationModel.firstname +
                        " " +
                        _vm.webDonationModel.lastname
                    )
                  )
                ]),
                _c("h2", { staticClass: "mt-4" }, [
                  _vm._v(
                    _vm._s(
                      "Thank you for your donation of $" +
                        _vm.webDonationModel.amount
                    )
                  )
                ]),
                _c("div", { staticClass: "mt-4" }, [
                  _vm._v(
                    " Please check your email for confirmation. If you don’t receive an email, please note that due to the high volume of donations we’ve received, it may take longer than normal for us to process your payment receipt. "
                  )
                ]),
                _c("div", { staticClass: "mt-4" }, [
                  _vm._v(
                    "For urgent questions, please call our supporter relations team on 1800 032 551"
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    !_vm.isCompleted && !_vm.isLoading
      ? _c("div", { staticClass: "container center" }, [
          _vm.isValidToken
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "border-2 border-gray-400 bg-green-50 p-3" },
                    [
                      _c("div", { staticClass: "flex flex-row" }, [
                        _c("span", { staticClass: "font-bold flex-1" }, [
                          _vm._v("Donor")
                        ]),
                        _c("span", { staticClass: "flex-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.webDonationModel.firstname +
                                " " +
                                _vm.webDonationModel.lastname
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "flex flex-row" }, [
                        _c("span", { staticClass: "font-bold flex-1" }, [
                          _vm._v("Appeal name")
                        ]),
                        _c("span", { staticClass: "flex-1" }, [
                          _vm._v(_vm._s(_vm.webDonationModel.productname))
                        ])
                      ]),
                      _c("div", { staticClass: "flex flex-row" }, [
                        _c("span", { staticClass: "font-bold flex-1" }, [
                          _vm._v("Donation type")
                        ]),
                        _c("span", { staticClass: "flex-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.webDonationModel.type === "Single"
                                ? "One time payment"
                                : "Regular payment"
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "flex flex-row" }, [
                        _c("span", { staticClass: "font-bold flex-1" }, [
                          _vm._v("Donation amount")
                        ]),
                        _c("span", { staticClass: "flex-1" }, [
                          _vm._v(
                            _vm._s(_vm._f("money")(_vm.webDonationModel.amount))
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._m(1),
                  _c("bambora-credit-card-form", {
                    key: _vm.bamboraFormKey,
                    on: {
                      startProcessingPayment: function($event) {
                        _vm.isLoading = true
                      },
                      finishProcessingPayment: function($event) {
                        _vm.isLoading = false
                      },
                      success: _vm.processPayment,
                      error: _vm.onError
                    }
                  }),
                  _vm.message
                    ? _c(
                        "div",
                        { staticClass: "mt-10" },
                        [_c("alert", { attrs: { message: _vm.message } })],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mb-14 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-5 mt-5 flex flex-row items-center" }, [
      _c("img", {
        staticClass: "w-12",
        attrs: { src: require("@/assets/img/secure-icon.svg") }
      }),
      _c("div", { staticClass: "flex flex-col ml-2 uppercase" }, [
        _c("div", { staticClass: "font-bold" }, [_vm._v("Secure")]),
        _c("div", [_vm._v("Payment")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }